<template>
  <div>
    <v-select
      v-model="unit_id"
      class="px-2"
      :items="units"
      item-text="name"
      item-value="id"
      label="Tópicos"
      :disabled="units.length === 0"
    >
      <template
        v-if="unit_id !== null"
        #append
      >
        <v-btn
          color="primary"
          text
          @click="unit_id = null"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-select>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  mixins: [
    handlesServerValidation
  ],
  props: {
    gradeId: { type: Number, default: undefined },
    gradeVolumeId: { type: Number, default: undefined },
    gradeSubjectId: { type: Number, default: undefined }
  },
  data: () => ({
    units: [],
    unit_id: null,
    parameters: ''
  }),
  watch: {
    unit_id () {
      this.setUnit()
    },
    gradeVolumeId () {
      this.listGradeUnits()
    },
    gradeSubjectId () {
      this.listGradeUnits()
    },
    async gradeId () {
      if (this.gradeId) {
        await this.listGradeUnits()
      } else {
        this.units = []
        this.unit_id = null
        this.setUnit()
      }
    }
  },

  methods: {
    setUnit () {
      this.$emit('setUnit', this.unit_id)
    },
    async listGradeUnits () {
      if (this.gradeVolumeId || this.gradeSubjectId) {
        this.parameters = '?'
      }
      if (this.gradeVolumeId) {
        this.parameters += `&grade_volume_id=${this.gradeVolumeId}`
      }
      if (this.gradeSubjectId) {
        this.parameters += `&grade_subject_id=${this.gradeSubjectId}`
      }
      try {
        this.units = await this.$api.listGradeUnits(this.gradeId, this.parameters)
        this.unit_id = null
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os tópicos, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
